document.addEventListener(
  'load',
  (e) => {
    if (e.target.tagName !== 'IMG') return;
    e.target.closest('.img-loader')?.setAttribute('data-img-loaded', '');
  },
  true
);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.img-loader img').forEach((img) => {
    if (img.complete && img.naturalWidth > 0) {
      img.closest('.img-loader')?.setAttribute('data-img-loaded', '');
    }
  });
});
